// The server sends the times of the log in UTC, without a zone
const parseUtc = (value: string): Date =>
  new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(value) ? value : `${value}Z`);

/**
 * A UTC time from the server as a local date and time, e.g. 10.10.2026 klo 17.40.
 */
const formatUtcDateTime = (value: null | string | undefined): string =>
  value
    ? parseUtc(value).toLocaleString('fi-FI', {
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        month: 'numeric',
        year: 'numeric',
      })
    : '';

// Whole minutes between two UTC times from the server, at least 1
const minutesBetween = (from: string, to: string): number =>
  Math.max(
    1,
    Math.round((parseUtc(to).getTime() - parseUtc(from).getTime()) / 60000)
  );

export { formatUtcDateTime, minutesBetween, parseUtc };
